import {useEffect} from 'react';

export type TailwindTheme = 'dark' | 'light';

export const useTailwindTheme = (theme: TailwindTheme) => {
  useEffect(() => {
    document.documentElement.classList.add(theme);

    return () => {
      document.documentElement.classList.remove(theme);
    };
  }, [theme]);
};
